import React from 'react';

const PaymentSection = ({ totalFee, isProcessing, handlePayNow, disabled = false, error = null }) => {
    return (
        <div className="mt-8">
            <div className="bg-white rounded-2xl shadow-lg p-6 border border-[#0d4f5c]/20">
                {error && (
                    <div className="mb-4 p-4 bg-red-50 border-l-4 border-red-500 rounded-lg">
                        <div className="flex items-start">
                            <div className="flex-shrink-0">
                                <svg className="h-5 w-5 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </div>
                            <div className="ml-3">
                                <p className="text-sm text-red-700">{error}</p>
                            </div>
                        </div>
                    </div>
                )}
                
                <div className="bg-[#0d4f5c]/10 rounded-xl p-6 text-center">
                    <p className="text-sm text-gray-600 mb-4">
                        By clicking "Pay Now" you will be redirected to the secure payment gateway
                    </p>
                    {disabled && (
                        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4 text-left">
                            <div className="flex">
                                <div className="flex-shrink-0">
                                    <svg className="h-5 w-5 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                    </svg>
                                </div>
                                <div className="ml-3">
                                    <p className="text-sm text-yellow-700">
                                        No fees to pay. Please select at least one fee category.
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}
                    <button
                        onClick={handlePayNow}
                        disabled={isProcessing || disabled || totalFee === 0}
                        className={`px-8 py-4 rounded-xl font-semibold text-white transition-all duration-200 flex items-center justify-center gap-3 shadow-lg text-lg mx-auto min-w-[200px]
                        ${!isProcessing && !disabled && totalFee > 0
                                ? 'bg-gradient-to-r from-[#0d4f5c] to-[#1a7a8a] hover:from-[#0a3f4a] hover:to-[#156a78] cursor-pointer transform hover:scale-105 active:scale-95'
                                : 'bg-gray-300 cursor-not-allowed opacity-60'
                            }
                        `}
                    >
                        {isProcessing ? (
                            <>
                                <svg className="animate-spin h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                Processing...
                            </>
                        ) : (
                            <>
                                Pay ₹{totalFee.toLocaleString()}
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                                </svg>
                            </>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PaymentSection;